
const StoreManagementModel = function (){
    const name = 'StoreManagement';
    return {
        name,
        state:{
            condition:{
                name:'',
            },
            newModal:{
                // areaId: "440303",
                // code: "",
                // email: "1234567890@qq.com",
                // id: "",
                // lat: "",
                // linkMan: "海涛",
                // linkMobile: "13100000000",
                // linkPhone: "13100000000",
                // lng: "",
                // logo: "https://4simg.xrtinfo.com//d28b4e79728f57a595e1c55bae50b6f2.jpg",
                // mchName: "海涛洗浴中心（罗湖分店）",
                // mchNo: "",
                // mobile: "13120000000",
                // name: "小李子",
                // parentNo: "",
                // regAddr: "罗湖大厦",
                // remark: "",
                id:'',
                mchNo:'',
                mchName:'',
                logo:'',
                code:'',
                regAddr:'',
                areaId:'',
                linkMan:'',
                linkMobile:'',
                linkPhone:'',
                remark:'',
                lat:'',
                lng:'',
                name:'',
                mobile:'',
                email:'',
                parentNo:'',
            },
            list:[],
            page:{
                pageSize:30,
                current:1,
                total:0,
            }
        },
        selectors:(state, props) => {
            const currentState = state[name];
            const selectors = {
                getCondition:()=>currentState.condition,
                getNewModalData:()=>currentState.newModal,
                getList:()=>currentState.list,
                getPage:()=>currentState.page,
            };
            return selectors;
        },
        api:{},
        actions:{
            changeCondition:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_STORECONDITION',
                    key,
                    value
                })
            },
            changeNewModalData:(key,value) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_STORENEW_MODAL',
                    key,
                    value
                })
            },
            changeList:(list) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_STORELIST',
                    list
                })
            },
            changePage:(page) => (dispatch,getState) => {
                dispatch({
                    type:'CHANGE_STOREPAGE',
                    page
                })
            }
        },
        reducers:{
            condition:(state = StoreManagementModel.state.condition, action) => {
                if(action.type === 'CHANGE_STORECONDITION'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            newModal:(state = StoreManagementModel.state.newModal, action) => {
                if(action.type === 'CHANGE_STORENEW_MODAL'){
                    const { key, value } = action;
                    const obj = {};
                    obj[key] = value;
                    return Object.assign({}, state, obj);
                }
                return state;
            },
            page:(state = StoreManagementModel.state.page, action) => {
                if(action.type === 'CHANGE_STOREPAGE'){
                    return Object.assign({}, state, action.page );
                }
                return state;
            },
            list:(state = StoreManagementModel.state.list , action ) => {
                if(action.type === 'CHANGE_STORELIST'){
                    return [ ...action.list ];
                };
                return state;
            }
        }
    }
}();

export default StoreManagementModel;


// WEBPACK FOOTER //
// ./src/models/StoreManagementModel.js